import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "featureId", "featureCategoryId", "onClick", "tooltip", "usageTracker", "usageTrackerAppLocationKey", "eventName", "eventProperties"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { BREEZE_SPECIAL } from '../../constants/BreezeUse';
import { NOT_USING_TRACKER, useTracker } from '../../hooks/useTracker';
import { AIBaseButton } from './internal/AIBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
const AIButton = _ref => {
  let {
      children,
      featureId,
      featureCategoryId,
      onClick,
      tooltip,
      usageTracker,
      usageTrackerAppLocationKey,
      eventName,
      eventProperties
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    aiTracker,
    legacyTracker
  } = useTracker(usageTracker, usageTrackerAppLocationKey);
  if (props.use === BREEZE_SPECIAL) {
    console.warn('BREEZE_SPECIAL is not meant for external use. Please use a different use type.');
  }
  const handleClick = event => {
    if (onClick) {
      onClick(event);
      if (aiTracker) {
        aiTracker.track('Ai Components Ui Library', 'Aibuttoninteraction', {
          type: 'trigger',
          featureId,
          featureCategoryId
        });
        // Custom tracking
        if (eventName && eventProperties && usageTracker !== NOT_USING_TRACKER && legacyTracker) {
          legacyTracker.track(eventName, eventProperties);
        }
      }
    }
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    title: tooltip,
    children: /*#__PURE__*/_jsx(AIBaseButton, Object.assign({}, props, {
      "data-test-id": props['data-test-id'] || 'ai-button',
      onClick: handleClick,
      children: children
    }))
  });
};
AIButton.displayName = 'AIButton';
export default AIButton;